import styled from 'styled-components'

interface CardOptions {
  isRedCard: boolean
}

export const DataCardContainer = styled.div<CardOptions>`
  font-family: 'Poppins';
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5em;
  border-radius: 10px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  width: calc(100% * (1 / 2) - 20px);
  height: 179px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  align-content: space-around;
  position: relative;
  gap: 10px;
  background: ${props => (props.isRedCard ? '#D82036' : 'white')};
  color: ${props => (props.isRedCard ? 'white' : '#0b0a0a')};
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    width: calc(100% * (1 / 2) - 15px);
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    height: 150px;
    gap: 5px;
    width: calc(100% * (1 / 2) - 10px);
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    height: 153px;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: 100%;
  }
`

export const Title = styled.p`
  font-size: 1.4em;
  word-break: break-word;
  position: absolute;
  bottom: 76%;
  top: 6.4%;
  margin: 0;
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    font-size: 1.2em;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
  }
`

export const MainValue = styled.p`
  font-weight: 600;
  font-size: 3.2em;
  line-height: 1em;
  margin: 0;
  @media (max-width: ${props => props.theme.breakpoints.xxl}px) {
    font-size: 2.5em;
  }
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    font-size: 2em;
  }
`

export const Quantifier = styled.p`
  font-weight: 400;
  font-size: 1.4em;
  margin: 0;
  @media (max-width: ${props => props.theme.breakpoints.xxl}px) {
    font-size: 1.2em;
  }
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    font-size: 1.2em;
  }
`

export const Quantity = styled.p`
  font-weight: 600;
  font-size: 1.6em;
  margin: 0;
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    font-size: 1.4em;
  }
`

export const Footer = styled.p`
  font-size: 13px;
  word-break: break-word;
  margin: 0;
  position: absolute;
  bottom: 10.61%;
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    font-size: 13px;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 13px;
  }
`
